"use client";

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormMessage,
} from "@/shared/components/ui/form";
import { Textarea } from "@/shared/components/ui/textarea";
import { BaseFieldProps } from "./form-field-utils";
import { FormFieldLabel } from "./form-field-label";

export function FieldTextarea({
  name,
  label,
  description,
  className,
  labelType = "text",
  tooltipContent,
  ...rest
}: BaseFieldProps & React.ComponentProps<typeof Textarea>) {
  return (
    <FormField
      name={name}
      render={({ field }) => (
        <FormItem className={className}>
          <FormFieldLabel label={label} labelType={labelType} tooltipContent={tooltipContent} />
          <FormControl>
            <Textarea {...field} {...rest} />
          </FormControl>
          {description && <FormDescription>{description}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
